import { PaymentMethod } from "@appTypes/index";

export const getWalletLabel = (type?: string | null): string => {
  const typeLower = type?.toLowerCase() ?? "";
  if (typeLower.startsWith("paypal")) return "PayPal";
  if (typeLower.startsWith("googlepay")) return "Google Pay";
  if (typeLower.startsWith("applepay")) return "Apple Pay";
  return "";
};

export const isWalletType = (type?: string | null): boolean =>
  getWalletLabel(type) !== "";

export const getLastFour = (maskedCardNumber?: string | null): string =>
  maskedCardNumber?.replace(/\D/g, "").slice(-4) ?? "";

export const getPaymentMethodTitle = (
  paymentMethod: PaymentMethod,
): string => {
  if (isWalletType(paymentMethod.type)) {
    return getWalletLabel(paymentMethod.type);
  }
  const lastFour = getLastFour(paymentMethod.maskedCardNumber);
  return `${paymentMethod.accountHolderName ?? ""} ****${lastFour}`;
};

export const getPaymentMethodSubtitle = (
  paymentMethod: PaymentMethod,
): string => {
  if (isWalletType(paymentMethod.type)) {
    const label = getWalletLabel(paymentMethod.type);
    return `Manage payment method on ${label}`;
  }
  if (
    paymentMethod.expirationMonth != null
    && paymentMethod.expirationYear != null
  ) {
    return `Expires ${paymentMethod.expirationMonth}/${paymentMethod.expirationYear}`;
  }
  return "";
};

export const isPaymentMethodExpired = (
  paymentMethod: PaymentMethod,
): boolean => {
  if (
    paymentMethod.expirationMonth == null
    || paymentMethod.expirationYear == null
  ) {
    return false;
  }
  return new Date(
    paymentMethod.expirationYear,
    paymentMethod.expirationMonth,
  ) < new Date();
};

export const getPaymentMethodIconType = (
  paymentMethod: PaymentMethod,
): string => paymentMethod.cardType ?? paymentMethod.type ?? "";
